import {
  Home,
  Search,
  User,
  BriefcaseBusiness,
  Gem,
  Info,
  Users,
  Settings,
  LayoutDashboard,
  CreditCard,
  Receipt,
  Bookmark,
  Mail,
  type LucideIcon,
} from 'lucide-react';

export const NAV_PATH_META_MAP: Record<string, { icon: LucideIcon }> = {
  '/': { icon: Home },
  '/home': { icon: Search },
  '/profile': { icon: User },
  '/job-postings': { icon: BriefcaseBusiness },
  '/subscription': { icon: Gem },
  '/about': { icon: Info },
  '/candidates': { icon: Users },
  '/my-candidates': { icon: Users },
  '/my-job-postings': { icon: BriefcaseBusiness },
  '/settings': { icon: Settings },
};

/** 右上角 UserMenu 及左側 AccountLayout 共用的帳戶選單 */
export const ACCOUNT_MENU_ITEMS: Array<{
  path: string;
  label: string;
  labelKey: string;
  icon: LucideIcon;
  employerOnly?: boolean;
  helperOnly?: boolean;
}> = [
  { path: '/home',              label: '主控台',     labelKey: 'nav.dashboard', icon: LayoutDashboard },
  { path: '/profile',           label: '我的檔案',   labelKey: 'nav.profile',   icon: User },
  { path: '/helper/saved-jobs',    label: '我儲存的工作', labelKey: 'nav.savedJobs',   icon: Bookmark, helperOnly: true },
  { path: '/helper/invitations',   label: '收到的邀請',   labelKey: 'nav.invitations', icon: Mail,     helperOnly: true },
  { path: '/payment/plans',     label: '訂閱',       labelKey: 'nav.payment',   icon: CreditCard, employerOnly: true },
  { path: '/orders',            label: '訂閱紀錄',   labelKey: 'nav.orders',    icon: Receipt,    employerOnly: true },
  { path: '/settings',          label: '設定',       labelKey: 'nav.settings',  icon: Settings },
];

export const SETTINGS_SUB_ITEMS = [
  { tab: 'account', label: '帳戶設定', labelKey: 'nav.accountSettings' },
  { tab: 'security', label: '安全', labelKey: 'nav.security' },
  { tab: 'appearance', label: '外觀', labelKey: 'nav.appearance' },
] as const;

